import { useContext } from "react";
import { AssessmentContext } from "context/session/AssessmentProvider";

export default function useAssessmentContext() {
  const context = useContext(AssessmentContext);
  if (!context) {
    throw new Error("useAssessmentContext must be used within an AssessmentProvider");
  }
  return context;
}
